import * as ViewModel from '@/core/presenter/viewModel/viewTypes';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  lastLoginTime: string;
  isOpen: boolean;
  onClickToggleBtn: () => void;
  onClickLogoutBtn: () => void;
  onChangeSettingViewType: (type: ViewModel.SettingViewType) => void;
  onClickAddHomeBtn: () => void;
}

const MainView = ({
  lastLoginTime,
  isOpen,
  onClickToggleBtn,
  onClickLogoutBtn,
  onChangeSettingViewType,
  // onClickAddHomeBtn,
}: IProps) => {
  const handleClickMovePinSettingView = useCallback(() => {
    onChangeSettingViewType(ViewModel.SettingViewType.PIN_SETTING);
  }, [onChangeSettingViewType]);

  return (
    <div className="container-style2">
      <div className="section-account">
        <div className="inner">
          <div className="section-title" onClick={onClickToggleBtn}>
            <div className="icon">
              <img src="img/acc_admin_ico.png" alt="icon" />
            </div>
            <h2 className="body-l-n fw-l">계정 관리</h2>
            <span className="arrow">
              <i className={clsx('bi', isOpen ? 'bi-chevron-up' : 'bi-chevron-down', 'dropdown-icon')}></i>
            </span>
          </div>
          <ul className={clsx('section-content', isOpen ? 'show_important' : '')}>
            <li className="body-n-n pointer_cursor">
              <a onClick={() => onChangeSettingViewType(ViewModel.SettingViewType.PWD_SETTING)}>비밀번호 재설정</a>
            </li>
            <li className="body-n-n pointer_cursor">
              <a onClick={handleClickMovePinSettingView}>PIN 비밀번호 재설정</a>
            </li>
            {/* <li className="body-n-n pointer_cursor">
              <a onClick={onClickAddHomeBtn}>홈화면에 추가</a>
            </li> */}
            <li className="body-n-n pointer_cursor">
              <a onClick={onClickLogoutBtn}>로그아웃</a>
            </li>
            <li className="body-n-n pointer_cursor">
              <a onClick={() => onChangeSettingViewType(ViewModel.SettingViewType.EXIT)}>회원탈퇴</a>
            </li>
          </ul>
        </div>
        {lastLoginTime && <div className="bot body-s-n">마지막 로그인일시: {lastLoginTime}</div>}
      </div>
    </div>
  );
};

export default MainView;
